import { render, staticRenderFns } from "./CRestFacilities.vue?vue&type=template&id=4d149a90"
import script from "./CRestFacilities.vue?vue&type=script&lang=js"
export * from "./CRestFacilities.vue?vue&type=script&lang=js"
import style0 from "./CRestFacilities.vue?vue&type=style&index=0&id=4d149a90&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d149a90')) {
      api.createRecord('4d149a90', component.options)
    } else {
      api.reload('4d149a90', component.options)
    }
    module.hot.accept("./CRestFacilities.vue?vue&type=template&id=4d149a90", function () {
      api.rerender('4d149a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CRestFacilities.vue"
export default component.exports